module.exports = __webpack_public_path__ + "media/dashboard/assets/images/brain-active-6ab778b0df59b8495f9fc5a646869e65.svg";